import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ReviewExperienceLayoutComponent } from "./review-experience-layout/review-experience-layout.component";
import { OptinComponent } from "./optin/optin.component";
import { OptoutComponent } from "./optout/optout.component";
import { CampaignSmsTrackingComponent } from "./campaign-sms-tracking/campaign-sms-tracking.component";
import { CustomerAppointmentBookingComponent } from "./customer-appointment-booking/customer-appointment-booking.component";
import { DeleteAppoinementComponent } from "./delete-appoinement/delete-appoinement.component";
import { CustomerBookAppointmentComponent } from "./customer-book-appointment/customer-book-appointment.component";
import { BookingComponent } from "./booking/booking.component";
import { BookingInquiryComponent } from "./booking-inquiry/booking-inquiry.component";
import { BookingConfirmationComponent } from "./booking-confirmation/booking-confirmation.component";
import { InquiryComponent } from "./inquiry/inquiry.component";
import { ReviewReplyComponent } from "./review-reply/review-reply.component";
import { AiReviewExperienceLegacyComponent } from "./ai-review-experience-legacy/ai-review-experience-legacy.component";
import { AiReviewExperienceDemoComponent } from "./ai-review-experience-demo/ai-review-experience-demo.component";
import { AiReviewExperienceVerticalComponent } from "./ai-review-experience-vertical/ai-review-experience-vertical.component";
import { AiReviewGenComponent } from "./ai-review-gen/ai-review-gen.component";

export const App1Routes: Routes = [
  { path: "ai-review-gen", component: AiReviewGenComponent },
  // Single-page AI review flow (ported from the standalone review app).
  { path: "ai-review/:id", component: AiReviewGenComponent },
  // Archived 4-step flow, kept reachable for fallback/comparison.
  { path: "ai-review-legacy/:id", component: AiReviewExperienceLegacyComponent },
  { path: "ai-review-demo/:id", component: AiReviewExperienceDemoComponent },
  { path: "ai-review-v2/:id", component: AiReviewExperienceVerticalComponent },
  { path: ":id", component: ReviewExperienceLayoutComponent },
  { path: "rr/:id", component: ReviewReplyComponent },
  {
    path: "campaign/:campaign_id/:contact_id",
    component: CampaignSmsTrackingComponent,
  },
  { path: "opt-in/:slug", component: OptinComponent },
  { path: "opt-out/:medium/:slug", component: OptoutComponent },
  { path: "customer/appointment/:id", component: DeleteAppoinementComponent },
  // {
  //   path: "customer/book-appointment/:slug",
  //   component: CustomerAppointmentBookingComponent,
  // },
  {
    path: "customer/old/book-appointment/:slug",
    component: CustomerAppointmentBookingComponent,
  },
  {
    // path: "customer/appointment-booking/:slug",
    path: "customer/book-appointment/:slug",
    component: CustomerBookAppointmentComponent,
  },
  {
    // path: "customer/appointment-booking/book/:slug",
    path: "customer/book-appointment",
    component: BookingComponent,
  },
  {
    path: "customer/booking-inquiry",
    component: BookingInquiryComponent,
  },
  {
    path: "customer/booking-confirmation",
    component: BookingConfirmationComponent,
  },
  {
    path: "customer/inquiry",
    component: InquiryComponent,
  },

  {
    path: "qr/:id",
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./reviews-qr/reviews-qr.module").then(
            (m) => m.ReviewsQrModule
          ),
      },
    ],
  },
];
